module.exports = __webpack_public_path__ + "static/img/solution_img_6.2477359.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/nav-solution/solution-h/solution_img_6.png
// module id = x5+A
// module chunks = 22